import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BankaHavaleEftPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-banka-havale-eft',
  templateUrl: 'banka-havale-eft.html',
})
export class BankaHavaleEftPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
 
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/BankaIslemleri/banka-havale-eft/banka-havale-eft.ts